import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import amplitude from 'amplitude-js';
import moment from 'moment-timezone';
import { Observable, Subscription } from 'rxjs';

import { Program } from '../../../models/programs.model';
import {
  DuplicateProgramFailure,
  DuplicateProgramRequest,
  DuplicateProgramSuccess,
} from '../../../states/programs.actions';

@Component({
  selector: 'rk-duplicate-program-modal',
  templateUrl: './duplicate-program-modal.component.html',
  styleUrls: ['./duplicate-program-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuplicateProgramModalComponent implements OnInit {
  duplicateProgramForm: UntypedFormGroup;

  isSaving$: Observable<boolean>;
  subscription = new Subscription();

  get duplicateProgramName(): string {
    return this.translate.instant('MODAL.DUPLICATE_PROGRAM.NAME_PREFIX', {
      name: this.program.name,
    });
  }

  constructor(
    public readonly dialogRef: MatDialogRef<DuplicateProgramModalComponent>,
    private readonly uiHelper: UiStoreHelperService,
    private readonly actions$: Actions,
    private readonly translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public program: Program,
  ) {}

  ngOnInit(): void {
    this.isSaving$ = this.uiHelper.getLoadingState(DuplicateProgramRequest, [
      DuplicateProgramSuccess,
      DuplicateProgramFailure,
    ]);
    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(DuplicateProgramSuccess))
        .subscribe(() => this.dialogRef.close()),
    );
    this.duplicateProgramForm = new UntypedFormBuilder().group({
      name: [this.duplicateProgramName, Validators.required],
    });
  }

  @Dispatch()
  submit = () => {
    amplitude.getInstance().logEvent('duplicate_program');
    const program: Program = {
      ...this.program,
      id: this.program.id,
      name: this.duplicateProgramForm.value['name'],
      createdAt: moment(),
    };

    return new DuplicateProgramRequest(program);
  };

  onCancel() {
    this.dialogRef.close(false);
  }
}
